import React from "react";

const specialOffers = [
  {
    location: "Pune → Mumbai Airport",
    title: "Toyota Etios",
    image: "/images/gallery/7.avif",
    originalPrice: "₹2500",
    discountedPrice: "₹1999",
    discount: "20%",
  },
  {
    location: "Pune Local Ride",
    title: "Ertiga",
    image: "/images/gallery/4.jpg",
    originalPrice: "₹2000",
    discountedPrice: "₹1699",
    discount: "15%",
  },
  {
    location: "Pune → Lonavala Round Trip",
    title: "Innova Crysta",
    image: "/images/gallery/6.jpg",
    originalPrice: "₹3500",
    discountedPrice: "₹2975",
    discount: "15%",
  },
];

const toNum = (s) => Number(String(s).replace(/[^\d]/g, "")) || 0;

const SpecialOffersSection = () => {
  return (
    <section className="pc-special">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-4">
          <h5 className="pc-dash">OUR FLEETS</h5>
          <h2 className="pc-heading">SPECIAL CAB</h2>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {specialOffers.map((offer, i) => {
            const save = Math.max(
              toNum(offer.originalPrice) - toNum(offer.discountedPrice),
              0
            );
            return (
              <div className="col-md-6 col-lg-4 justify-content-center" key={i}>
                <article className="pc-offer">
                  <div className="pc-media">
                    <img className="pc-car" src={offer.image} alt={offer.title} loading="lazy" />
                    <span className="pc-badge">{offer.discount} OFF</span>
                    <span className="pc-rail" aria-hidden />
                  </div>

                  <div className="pc-body">
                    <div className="pc-route text-center">{offer.location}</div>
                    <h3 className="pc-title text-center">{offer.title}</h3>

                    

                    <ul className="pc-perks text-center">
                      <li>AC</li>
                      <li>Clean Cab</li>
                      <li>Pro Driver</li>
                    </ul>

                    <div className="pc-cta Justify-content-center">
                      <a href="/booking" className="pc-btn text-center">
                        Book Now <span>›</span>
                      </a>
                      
                    </div>
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SpecialOffersSection;
